import { OrderStatus, PaymentStatus } from 'shared/models'

const paymentStatusText: Record<PaymentStatus, string> = {
  Failed: 'Отклонено',
  None: '',
  Paid: 'Предоплачено',
  Requested: 'Запрошено'
}

const orderStatusText: Record<OrderStatus, string> = {
  Created: 'Создан',
  CallConfirmed: 'Обзвонен',
  CallFailed: 'Не дозвонились',
  Cancelled: 'Отменен',
  Confirmed: 'Подтвержден',
  Completed: 'Завершен'
}

const orderStatusColor: Record<OrderStatus, string> = {
  Cancelled: '#fff',
  CallConfirmed: '#fff',
  CallFailed: '#fff',
  Confirmed: '#fff',
  Created: '#000',
  Completed: '#0000006b'
}

const orderStatusBackground: Record<OrderStatus, string> = {
  Cancelled: '#e01b1b',
  CallConfirmed: '#5667f4',
  CallFailed: '#f4a41d',
  Confirmed: '#11b511',
  Created: '#e7e7e7',
  Completed: '#0000000d'
}

export { paymentStatusText, orderStatusText, orderStatusBackground, orderStatusColor }
